import React from 'react';
import { NumericFormat } from 'react-number-format';

interface OdometerInputProps {
  value: number;
  unit: string;
  customInput: React.ComponentType;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: any;
}

const OdometerInput = ({ value, unit, customInput, onChange, inputProps }: OdometerInputProps) => (
  <NumericFormat
    aria-labelledby="odometer-input"
    value={value}
    suffix={` ${unit}`}
    thousandSeparator=","
    onChange={onChange}
    type="tel"
    customInput={customInput}
    {...inputProps}
  />
);

export default OdometerInput;
